import React from "react";
import EnergicLogo from "../../../components/ui/EnergicLogo";
import './header.scss';
import Button from "../../../components/ui/button/Button";
import {Link} from "gatsby";
import headerMenu from "../../../config/HeaderMenu";
import {useTranslation} from "gatsby-plugin-react-i18next";
import DrawerMenu from "../drawerMenu/DrawerMenu";
import HeaderButtonWithSubmenus from "./HeaderButtonWithSubmenus";

const {
    home,
    challenge,
    tools,
    team,
    resources,
    mySpace,
    contact,
} = headerMenu;

interface Props {
    isHomePage?: boolean,
}

const Header = ({isHomePage = false}: Props) => {
    const {t} = useTranslation('common');
    return (
        <header className='mainHeader'>
            <Link to={home.route} className='energicLogoContainer' title="Lien vers l'accueil du site">
                <EnergicLogo />
            </Link>
            <div className='desktopMenu'>
                <div>
                    <HeaderButtonWithSubmenus menuItem={tools} />
                    <HeaderButtonWithSubmenus menuItem={challenge} />
                    <Link to={team.route} className='simpleLinkContainer'>
                        <Button
                            textOnly
                            label={t(team.title)}
                        />
                    </Link>
                    <HeaderButtonWithSubmenus menuItem={resources} />
                </div>

                <div>
                    {
                        isHomePage ? (
                            <HeaderButtonWithSubmenus menuItem={mySpace} />
                        ) : null
                    }
                    <Link to={contact.route} className='simpleLinkContainer'>
                        <Button
                            label={t(contact.title)}
                        />
                    </Link>
                </div>
            </div>
            <DrawerMenu isHomePage={isHomePage} />
        </header>
    );
};

export default Header;